import {
    createRouter,
    createWebHistory,
    RouteRecordRaw
} from "vue-router";
import Login from "@/views/Login.vue";
import Layout from "@/components/Layout/index.vue";
import {ElMessage} from "element-plus";
import {useUserStore} from "@/stores/user";
import NotFound from "@/views/NotFound.vue";
import {useKingdeeStore} from '@/stores/kingdeeStroe'

// 移除封装的lazyLoad函数，改用原生懒加载写法
const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        redirect: "/login",
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {title: "用户登录"},
    },
    {
        path: "/index",
        name: "Layout",
        component: Layout,
        meta: {requiresAuth: true},
        children: [
            // ✅ 核心修改：改用原生懒加载，适配Vue CLI
            {path: "home", name: "Home", component: () => import("@/views/Home.vue"), meta: {title: "首页"}},
            {
                path: "system/index",
                name: "System",
                component: () => import("@/views/system/index.vue"),
                meta: {title: "系统"}
            },
            {
                path: "system/baseData/user",
                name: "User",
                component: () => import("@/views/system/baseData/user.vue"),
                meta: {title: "用户新增"}
            },
            {
                path: "system/baseData/user-list",
                name: "UserList",
                component: () => import("@/views/system/baseData/user-list.vue"),
                meta: {title: "用户列表"}
            },
            {
                path: "system/baseData/user-detail/:id",
                name: "UserDetail",
                component: () => import("@/views/system/baseData/user-detail.vue"),
                meta: {title: "用户详情"}
            },
            {
                path: "system/baseData/role-list",
                name: "RoleList",
                component: () => import("@/views/system/baseData/role-list.vue"),
                meta: {title: "角色管理"}
            },
            {
                path: "system/baseData/permission-list",
                name: "PermissionList",
                component: () => import("@/views/system/baseData/permission-list.vue"),
                meta: {title: "权限管理"}
            },
            {
                path: "system/sync/manual-sync",
                name: "ManualSync",
                component: () => import("@/views/system/sync/manual-sync.vue"),
                meta: {title: "手动同步"}
            },
            {
                path: "system/log/log-list",
                name: "LogList",
                component: () => import("@/views/system/log/log-list.vue"),
                meta: {title: "日志列表"}
            },
            {
                path: "supply-chain/sales-manage/index",
                name: "SalesManagement",
                component: () => import("@/views/supply-chain/sales-manage/index.vue"),
                meta: {title: "销售管理"}
            },
            {
                path: "supply-chain/sales-manage/delivery-processing/sales-outbound-form/:billNo",
                name: "SalesOutboundForm",
                component: () => import("@/views/supply-chain/sales-manage/delivery-processing/sales-outbound-form.vue"),
                meta: {title: "销售出库单"}
            },
            {
                path: "supply-chain/sales-manage/delivery-processing/sales-outbound-form-list",
                name: "SalesOutboundFormList",
                component: () => import("@/views/supply-chain/sales-manage/delivery-processing/sales-outbound-form-list.vue"),
                meta: {title: "销售出库单列表"}
            },
            {
                path: "finc-account/cashier-manage/index",
                name: "CashierManageIndex",
                component: () => import("@/views/finc-account/cashier-manage/index.vue"),
                meta: {title: "出纳管理"}
            },
            {
                path: "finc-account/cashier-manage/routine-process/receipt-list",
                name: "ReceiptList",
                component: () => import("@/views/finc-account/cashier-manage/routine-process/receipt-list.vue"),
                meta: {title: "收款单列表"}
            },
            {
                path: "supply-chain/sales-manage/delivery-processing/recon-detail",
                name: "ReconDetail",
                component: () => import("@/views/supply-chain/sales-manage/delivery-processing/recon-detail.vue"),
                meta: {title: "对账单详情"}
            },
            {
                path: "supply-chain/sales-manage/delivery-processing/recon-list",
                name: "ReconList",
                component: () => import("@/views/supply-chain/sales-manage/delivery-processing/recon-list.vue"),
                meta: {title: "销售对账单列表"}
            },
            {
                path: "supply-chain/purchases-manage/material-receiving/purchases-recon-list",
                name: "PurchasesReconList",
                component: () => import("@/views/supply-chain/purchases-manage/material-receiving/purchases-recon-list.vue"),
                meta: {title: "采购对账单列表"}
            },
            {
                path: "supply-chain/sales-manage/delivery-processing/create-recon",
                name: "CreateRecon",
                component: () => import("@/views/supply-chain/sales-manage/delivery-processing/create-recon.vue"),
                meta: {title: "创建对账单"}
            },
            {
                path: "supply-chain/purchases-manage/index",
                name: "PurchasesManagement",
                component: () => import("@/views/supply-chain/purchases-manage/index.vue"),
                meta: {title: "采购管理"}
            },
            {
                path: "supply-chain/purchases-manage/material-receiving/purchases-list",
                name: "PurchasesList",
                component: () => import("@/views/supply-chain/purchases-manage/material-receiving/purchases-list.vue"),
                meta: {title: "采购入库单列表"}
            },
            {
                path: "supply-chain/purchases-manage/material-receiving/purchases-detail/:billNo",
                name: "PurchasesDetail",
                component: () => import("@/views/supply-chain/purchases-manage/material-receiving/purchases-detail.vue"),
                meta: {title: "采购入库单详情"}
            },
            {
                path: "basic-manage/basic-Information/index",
                name: "BasicInformation",
                component: () => import("@/views/basic-manage/basic-Information/index.vue"),
                meta: {title: "基础资料"}
            },
            {
                path: "basic-manage/basic-Information/master-data/bank-account-list",
                name: "BankAccount",
                component: () => import("@/views/basic-manage/basic-Information/master-data/bank-account-list.vue"),
                meta: {title: "银行账户列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/customer-list",
                name: "Customer",
                component: () => import("@/views/basic-manage/basic-Information/master-data/customer-list.vue"),
                meta: {title: "客户列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/department-list",
                name: "Department",
                component: () => import("@/views/basic-manage/basic-Information/master-data/department-list.vue"),
                meta: {title: "部门列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/emp-list",
                name: "Emp",
                component: () => import("@/views/basic-manage/basic-Information/master-data/emp-list.vue"),
                meta: {title: "职员列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/material-list",
                name: "Material",
                component: () => import("@/views/basic-manage/basic-Information/master-data/material-list.vue"),
                meta: {title: "物料列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/stock-list",
                name: "Stock",
                component: () => import("@/views/basic-manage/basic-Information/master-data/stock-list.vue"),
                meta: {title: "仓库列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/unit-list",
                name: "Unit",
                component: () => import("@/views/basic-manage/basic-Information/master-data/unit-list.vue"),
                meta: {title: "计量单位列表"}
            },
            {
                path: "basic-manage/basic-Information/master-data/supplier-list",
                name: "Supplier",
                component: () => import("@/views/basic-manage/basic-Information/master-data/supplier-list.vue"),
                meta: {title: "供应商列表"}
            },
            {
                path: "system/baseData/create-receipt",
                name: "CreateReceipt",
                component: () => import("@/views/system/baseData/create-receipt.vue"),
                meta: {title: "数据设置"}
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: NotFound,
        meta: {title: "页面不存在 - 404"}
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const userStore = useUserStore();
    const meta = to.meta as { title?: string; requiresAuth?: boolean };
    document.title = meta.title ?? "收银数据集成";
    const isNeedAuth = meta.requiresAuth ?? false;

    if (isNeedAuth) {
        // 用isTokenValid判断token是否真的有效（非空+未过期）
        if (userStore.isTokenValid()) {
            next();
        } else {
            ElMessage.warning("请先登录后再访问该页面！");
            next("/login");
        }
    } else {
        if (to.path === "/login" && userStore.isTokenValid()) {
            ElMessage.info("您已登录，无需重复登录！");
            next("/index/home");
        } else {
            next();
        }
    }
});

export default router;